import React from "react";
import { Typography } from "@material-ui/core";

export const FeatureCard = ({ item, classes }) => (
  <div className={classes.featureCard} style={{ textAlign: "center", paddingTop: 24 }}>
    <div style={{ display: "flex", justifyContent: "center", marginBottom: 16 }}>
      <div className={classes.featureIcon}>
        {item.icon}
      </div>
    </div>

    <Typography variant="h6" className={classes.cardHeading} gutterBottom style={{ marginTop: 8 }}>
      {item.title}
    </Typography>

    <Typography variant="body2" component="p">
      {item.description}
    </Typography>
  </div>
);

export const DetailListCard = ({
  title,
  items,
  classes,
}) => (
  <div className={classes.requirementsCard}>
    {title ? (
      <Typography
        variant="h6"
        className={classes.cardHeading}
        gutterBottom
      >
        {title}
      </Typography>
    ) : null}

    <div
      style={{
        display: "grid",
        gridTemplateColumns:
          "repeat(auto-fit,minmax(300px,1fr))",
        gap: "24px 32px",
      }}
    >
      {items.map((item, index) => (
        <div
          key={index}
          className={classes.detailItem}
          style={{
            display: "flex",
            gap: 14,
            alignItems: "flex-start",
            wordBreak: "break-word",
          }}
        >
          <div
            style={{
              minWidth: 50,
              display: "flex",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <div className={classes.smallIcon}>
              {item.icon}
            </div>
          </div>

          <div
            style={{
              flex: 1,
            }}
          >
            <Typography
              variant="subtitle2"
              className={
                classes.detailItemTitle
              }
              style={{
                lineHeight: 1.5,
                marginBottom: 6,
              }}
            >
              {item.title}
            </Typography>

            <Typography
              variant="body2"
              component="p"
              className={
                classes.detailItemText
              }
              style={{
                lineHeight: 1.7,
                wordBreak: "break-word",
              }}
            >
              {item.details}
            </Typography>
          </div>
        </div>
      ))}
    </div>
  </div>
);